<!-- <h1>Enter Mobile Number AND Pin For Login</h1>
<mat-form-field appearance="fill" style="width: 100% !important;">
    <mat-label>MOBILE NUMBER</mat-label>
    <input matInput type="number" [(ngModel)]="mobileNumber">
  </mat-form-field>
  <mat-form-field appearance="fill" style="width: 100% !important;">
    <mat-label>PIN</mat-label>
    <input matInput type="number" [(ngModel)]="pinNumber">
  </mat-form-field>
  <div class="example-button-row">
    <button class= "subButton" mat-button color="primary" (click)="submit()">SUBMIT</button>
  </div> -->
  <!-- <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Mobile Number AND PIN verification</h4>
  </div> -->
  <div class="modal-body">
    <form>
      <div class="mb-3">
        <label for="dateOfBirth">To unsubscribe send STOP PLAYPRO to 43006.</label>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="submit()" >SUBMIT</button>
  </div>